var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"superset-iframe",attrs:{"src":"https://superset.gie-us.es/superset/dashboard/p/nLBpMqLKpZA/","frameborder":"0","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }